import { Controller } from "@hotwired/stimulus"

import * as Bloomreach from "@/helpers/bloomreach"

export default class BloomreachSearchController extends Controller {
  static values = { data: Object }
  declare readonly dataValue: Bloomreach.EventProperties

  connect(): void {
    Bloomreach.searchEvent(this.dataValue)
  }
}
